import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    ten: { //object, optional // Tên Cơ sở lưu trú
        vi: null, //string, optional // Tên tiếng Việt
        en: null, //string, optional // Tên tiếng Anh
    },
    dia_chi: { //object, optional // Địa chỉ
        province_id: null, //IdRef, optional // Mã tỉnh/TP
        province_name: null, //string, optional // Tên tỉnh/TP
        commune_id: null, //IdRef, optional // Mã quận/huyện
        commune_name: null, //string, optional // Tên quận/huyện
        dia_chi: null, //string, optional // Địa chỉ đầy đủ
    },
    logo: null, //string, optional // Đường dẫn ảnh logo trên trang tổng cục du lịch
    dien_thoai: { //object, optional // Các thông tin điện thoại
        ma_vung: null, //string, optional // Mã vùng điện thoại
        tel: null, //string, optional // Điện thoại cố định
        fax: null, // string, optional // Số fax
    },
    email: null, //string, optional // Email
    website: null, //string, optional // Website
    loai_hinh_id: null, //IdRef, optional // Loại hình cơ sở lưu trú
    xep_hang_id: null, //IdRef, optional // Thông tin xếp hạng cơ sở lưu trú
    dich_vu_ids: [], //array of IdRef, optional // Danh sách các dịch vụ
    so_quyet_dinh: null, // string, optional // Số quyết định
    ngay_quyet_dinh: null, //string, optional // Ngày quyết định
    tong_so_phong: null, //integer, optional // Tổng số phòng
    gia: { //object, optional // Thông tin giá phòng
        thap_nhat: null, //integer, optional // Giá phòng thấp nhất
        cao_nhat: null, //integer, optional // Giá phòng cao nhất
    }
};

// validation form
model.validForm = {

    ten: { //object, optional // Tên Cơ sở lưu trú
        vi: [ValidService.required], //string, optional // Tên tiếng Việt
        en: [], //string, optional // Tên tiếng Anh
    },
    dia_chi: { //object, optional // Địa chỉ
        province_id: [], //IdRef, optional // Mã tỉnh/TP
        province_name: [], //string, optional // Tên tỉnh/TP
        commune_id: [], //IdRef, optional // Mã quận/huyện
        commune_name: [], //string, optional // Tên quận/huyện
        dia_chi: [], //string, optional // Địa chỉ đầy đủ
    },
    logo: [], //string, optional // Đường dẫn ảnh logo trên trang tổng cục du lịch
    dien_thoai: { //object, optional // Các thông tin điện thoại
        ma_vung: [], //string, optional // Mã vùng điện thoại
        tel: [], //string, optional // Điện thoại cố định
        fax: [], // string, optional // Số fax
    },
    email: [], //string, optional // Email
    website: [], //string, optional // Website
    loai_hinh_id: [], //IdRef, optional // Loại hình cơ sở lưu trú
    xep_hang_id: [], //IdRef, optional // Thông tin xếp hạng cơ sở lưu trú
    dich_vu_ids: [], //array of IdRef, optional // Danh sách các dịch vụ
    so_quyet_dinh: [], // string, optional // Số quyết định
    ngay_quyet_dinh: [], //string, optional // Ngày quyết định
    tong_so_phong: [], //integer, optional // Tổng số phòng
    gia: { //object, optional // Thông tin giá phòng
        thap_nhat: [], //integer, optional // Giá phòng thấp nhất
        cao_nhat: [], //integer, optional // Giá phòng cao nhất
    }
};

// dữ liệu mẫu các form khác
model.dataFormOther = {

};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["ten.vi", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            'ten.vi': "",
            'dia_chi.dia_chi': "",
            loai_hinh_id: "",
            xep_hang_id: "",
            dich_vu_ids: "",
            'gia.thap_nhat': "",
            'gia.cao_nhat': ""
        },
        valid: {
            'ten.vi': [],
            'dia_chi.dia_chi': [],
            loai_hinh_id: [],
            xep_hang_id: [],
            dich_vu_ids: [],
            'gia.thap_nhat': [],
            'gia.cao_nhat': []
        },
        operator: {
            'ten.vi': ":regex_i:", //:regex:, $vn_text=Viêt nam
            'dia_chi.dia_chi': ":regex_i:",
            'gia.thap_nhat': ">=",
            'gia.cao_nhat': "<=",
        }
    }
};

export default model;